import React, { useState , useEffect}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useStateContext } from '../../contexts/ContextProvider';
import {useClienteMutations} from '../../hooks/cliente/useClienteMutations';
import {useRegistroMutations} from '../../hooks/registro/useRegistroMutations';
import { FooterPages } from '..';
import rutValidator from '../../utils/validateRut';

import { fetchUser } from '../../utils/fetchUser';
import { Toaster,toast } from 'react-hot-toast';
import Select from 'react-select';
import {getPlanes} from "../../services/Planes";
import {getComunas} from "../../services/Comunas";
import {getDropoffs} from "../../services/dropoff";
import {getRecolectoresEstado} from "../../services/Recolectores";

import ButtonToolBar from '../ButtonToolBar';
import {formatDate} from '../../formatters/date';


const initialState = {
empresa: null,
numeroRegistro: 0,
idPlan: null,
nombrePlan: '',
valor: '',
tipoPlan: '',
frecuencia: 'Semanal',
idCliente: '',
rutCliPro: '',
razonSocial:'',
direccion: '',
numero: '',
telefono:'',
email:'',
idComuna: '',
nombreComuna: '',
nombreCiudad: '',
descripcion:'',
estado: 'Activo',
idDropoff: '',
idRecolector: ''
};

const NuevaRegistro = ({vecinoData, onChangeVecino}) => {
  const { isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const [comunaData, setComunaData] = useState([]);
  const [planesData, setPlanesData] = useState([]);
  const [puntosData, setPuntosData] = useState([]);
  const [recolectoresData, setRecolectoresData] = useState([]);

  const { addCliente, updateClienteD } = useClienteMutations();
  const { addRegistro, updateRegistroD } = useRegistroMutations();

  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  const [buttonsTool, setButtonsTool] = useState([
    { name: 'cancel', label: 'Cancelar', disabled: false },
    { name: 'save', label: 'Guardar', disabled: false },
  ]);

  const userInfo = fetchUser();

  useEffect(() => {
    if(vecinoData) {
      setFormData(vecinoData);
    }
  }, [vecinoData]);

  useEffect(()=>{
    const fetchData = async () => {
      const misPlanes = await getPlanes();
      console.log(misPlanes);
      setPlanesData(misPlanes);
      const misComunas = await getComunas();
      setComunaData(misComunas);
      const misPuntos = await getDropoffs();
      setPuntosData(misPuntos);
      const misRecolectores = await getRecolectoresEstado('Activo');
      setRecolectoresData(misRecolectores);
    };
    fetchData();
  },[]);

  useEffect(() => {
    if (formData.idPlan !== "" && formData.idPlan !== undefined) {
      const cSel = planesData.find((item) => item._id === formData.idPlan);
      if (cSel) {
        setFormData((prev) => ({
          ...prev,
          valor: cSel.valor, tipoPlan: cSel.tipoPlan, nombrePlan: cSel.nombrePlan
        }));
      }
    }
  }, [formData.idPlan, planesData]);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  
  const handleSubmit = async () =>{
    
    try {
      
      if( !rutValidator(formData.rutCliPro))
        {
          toast.error('RUT Ingresado no es Válido!');
          return;
        }
      if( formData.idPlan === '' || formData.idPlan === null || formData.idPlan === undefined )
        {
          toast.error('Debe seleccionar un Plan!');
          return;
        }
      if( formData.rutCliPro === '' || formData.rutCliPro === null || formData.rutCliPro === undefined )
        {
          toast.error('Debe ingresar un RUT!');
          return;
        }
      if( formData.razonSocial === '' || formData.razonSocial === null || formData.razonSocial === undefined )
        {
          toast.error('Debe ingresar un Nombre!');
          return;
        }
      if( formData.direccion === '' || formData.direccion === null || formData.direccion === undefined )
        {
          toast.error('Debe ingresar una Dirección!');
          return;
        }
      if( formData.telefono === '' || formData.telefono === null || formData.telefono === undefined )
        {
          toast.error('Debe ingresar un Teléfono!');
          return;
        }
      if( formData.email === '' || formData.email === null || formData.email === undefined )
        {
          toast.error('Debe ingresar un Email!');
          return;
        }
      if( formData.idComuna === '' || formData.idComuna === null || formData.idComuna === undefined )
        {
          toast.error('Debe seleccionar una Comuna!');
          return;
        }

      if (formData.tipoPlan === 'Entrega' && (formData.idDropoff === '' || formData.idDropoff === null || formData.idDropoff === undefined)   )
        {
          toast.error('Debe seleccionar un Punto de Drop Off!');
          return;
        }

      if (formData.tipoPlan !== 'Entrega' && (formData.idRecolector === '' || formData.idRecolector === null || formData.idRecolector === undefined)   )
        {
          toast.error('Debe seleccionar un Recolector!');
          return;
        }   


      let miLon = -70.6693;
      let miLat = -33.4489;
        try {
            const query = `${formData.direccion} ${formData.numero}, ${formData.nombreComuna}, ${formData.nombreCiudad}`;
              const response = await fetch(
                `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}`
              );
              
              const data = await response.json();
              
              if (data.length === 0) {
                console.log('Dirección no encontrada');
              } else{
                let { lat, lon } = data[0];
                miLon = parseFloat(lon);
                miLat = parseFloat(lat);
                console.log('Coordenadas obtenidas:', miLat, miLon);
              }
        } catch (error) {
              console.log('Error al geocodificar la dirección:', error); 
        }
 
      
      if(!vecinoData._id) 
        {
          const clienteData = {
            empresa: userInfo.empresa,
            rutCliPro: formData.rutCliPro,
            razonSocial: formData.razonSocial,
            giro: '',
            direccion: formData.direccion,
            numero: formData.numero,
            telefono: formData.telefono,
            email: formData.email,
            descripcion: '',
            idComuna: formData.idComuna,
            contacto: '',
            estado: 'Activo',
            fechaCreacion: Date.now(),
            lat: miLat,
            lng: miLon,
            idRecolector: formData.idRecolector,
            idDropoff: formData.idDropoff
          };
          const newClient = await addCliente.mutateAsync(clienteData);
    
          const datosSolicitud = {
            empresa: userInfo.empresa,
            numeroRegistro: 0,
            idPlan: formData.idPlan,
            idCliente: newClient._id,
            frecuencia: formData.frecuencia,
            descripcion: formData.descripcion,
            estado: 'Activo',
            fechaCreacion: Date.now()
          };
          await addRegistro.mutateAsync( datosSolicitud );

        } else
        { 

          const clienteData = {
            _id: vecinoData.idCliente,
            empresa: userInfo.empresa,
            rutCliPro: formData.rutCliPro,
            razonSocial: formData.razonSocial,
            giro: '',
            direccion: formData.direccion,
            numero: formData.numero,
            telefono: formData.telefono,
            email: formData.email,
            descripcion: '',
            idComuna: formData.idComuna,
            contacto: '',
            estado: 'Activo',
            fechaCreacion: Date.now(),
            lat: miLat,
            lng: miLon,
            idRecolector: formData.idRecolector,
            idDropoff: formData.idDropoff
          };
          const newClient = await updateClienteD.mutateAsync(clienteData);

          const updatosSolicitud = {
            _id: vecinoData._id,
            empresa: userInfo.empresa,
            numeroRegistro: formData.numeroRegistro,
            idPlan: formData.idPlan,
            idCliente: formData.idCliente,
            frecuencia: formData.frecuencia,
            descripcion: formData.descripcion,
            estado: formData.estado
          };
          await updateRegistroD.mutateAsync( updatosSolicitud );
        };
        onChangeVecino('REFRESH');
        setIsClicked( !isClicked.nuevasolicitud );

    } catch (error) {
      console.log("Problemas al momento de Registrar Cliente y Plan, contacte a soporte" + error);
      toast.error("Problemas al momento de Registrar Cliente y Plan, contacte a soporte");
    }
  }
 
  const handleCancelar = async () =>{  
    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevasolicitud );
  }

  const handleButtonToolBarClick = (buttonName) => {
    if (buttonName === 'save') {
      handleSubmit();
    } else if (buttonName === 'cancel') {
      handleCancelar();
    }
  };

  const comunaOptions = comunaData.map((item) => ({
    value: item._id,
    label: `${item.codigoComuna} - ${item.nombreComuna}`,
  }));

  return (
    <form  onSubmit={handleSubmit} >
     <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
     <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-3/4 p-8">
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-green-800 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                Registro Cliente
              </p>
            </div>

            <button
              type="button"
              onClick={() => setIsClicked(!isClicked.nuevasolicitud)}
              className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <MdOutlineCancel className="text-xl md:text-2xl" />
            </button>
          </div>

     <div className="bg-gray-200 p-6 rounded-lg shadow-lg mt-2">
        <div className="grid grid-cols-3 md:grid-cols-6 gap-4" >
            <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">N° Registro</label>            
                <input
                className={inputClass}
                type="text"
                placeholder=""
                name="numeroRegistro"
                value= {formData.numeroRegistro}
                disabled
              />
            </div>
            <div className="flex flex-col items-start">      
              <label className="text-xs font-semibold mb-1">Fecha</label>            
              <input
                className={inputClass}
                type="text"
                placeholder=""
                name="fechaCreacion"
                value= {formatDate(formData.fechaCreacion)}
                disabled
              />
            </div>
            <div className="col-span-2">
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Plan</label>
                  <select className={inputClass} name="idPlan" 
                  value= {formData.idPlan} 
                  required
                  onChange={handleChange}>
                    <option value=""></option>
                    {planesData?.map((item, index) => (
                      <option  key={item._id} value={item._id}>{item.nombrePlan}</option>
                    ))}  
                    </select> 
              </div> 
            </div> 
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Valor</label>
                <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="valor"
                  value= {formData.valor}
                  disabled
                  onChange={handleChange}
                />
              </div>  

              <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Frecuencia</label>
                    <select className={inputClass} name="frecuencia" value= {formData.frecuencia} onChange={handleChange}>
                    <option value="Diario">Diario</option>
                      <option value="Semanal">Semanal</option>
                      <option value="Mensual">Mensual</option>
                    </select>
              </div>
            </div>    
        </div>   

          <div className="mt-5 space-y-4">
          <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
              <div className="grid grid-cols-3 md:grid-cols-6 gap-4" >
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Rut</label>
                  <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="rutCliPro"
                  value= {formData.rutCliPro}
                  onChange={handleChange}
                  disabled = {vecinoData && (!vecinoData._id ? false : true)}
                  />
                </div> 
              
                <div className="col-span-2">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Nombre</label>
                    <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="razonSocial"
                      value= {formData.razonSocial}
                      onChange={handleChange}
                      disabled = {vecinoData && (!vecinoData._id ? false : true)}
                    />
                  </div> 
                </div>
                <div className="col-span-3">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Dirección</label>
                    <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="direccion"
                      value= {formData.direccion}
                      onChange={handleChange}
                      disabled = {vecinoData && (!vecinoData._id ? false : true)}
                    />
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mt-2" >
                    <div className="flex flex-col">
                        <label className="text-xs font-semibold mb-1">Número</label>
                        <input
                            className={inputClass}
                            type="text"
                            placeholder=""
                            name="numero"
                            value= {formData.numero}
                            onChange={handleChange}
                            disabled = {vecinoData && (!vecinoData._id ? false : true)}
                          />
                      </div>
                    <div className="flex flex-col">
                        <label className="text-xs font-semibold mb-1">Teléfono</label>
                        <input
                            className={inputClass}
                            type="text"
                            placeholder=""
                            name="telefono"
                            value= {formData.telefono}
                            onChange={handleChange}
                            disabled = {vecinoData && (!vecinoData._id ? false : true)}
                          />
                      </div>
                      <div className="flex flex-col">
                        <label className="text-xs font-semibold mb-1">Mail</label>
                        <input
                            className={inputClass}
                            type="text"
                            placeholder=""
                            name="email"
                            value= {formData.email}
                            onChange={handleChange}
                            disabled = {vecinoData && (!vecinoData._id ? false : true)}
                          />
                      </div>

                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Comuna</label>
                    <Select
                      options={comunaOptions}
                      value={comunaOptions.find((option) => option.value === formData.idComuna)}
                      onChange={(selectedOption) => {
                        if (selectedOption) {
                          const comunaSeleccionada = comunaData.find(c => c._id === selectedOption.value);

                          setFormData((prev) => ({
                            ...prev,
                            idComuna: selectedOption.value,
                            nombreCiudad: comunaSeleccionada?.nombreCiudad || '',
                          }));
                        } else {
                          // Si se limpia el campo
                          setFormData((prev) => ({
                            ...prev,
                            idComuna: '',
                            nombreCiudad: '',
                          }));
                        }
                      }}
                      className="text-xs"
                      placeholder="Buscar ..."
                      isClearable
                      disabled = {vecinoData && (!vecinoData._id ? false : true)}
                    />

                  </div>

                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Ciudad</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        disabled
                        name="nombreCiudad"
                        value= {formData.nombreCiudad}
                        onChange={handleChange}
                      />
                  </div>  

                </div>

              </div>
              <div className="bg-white p-6 rounded-lg shadow-lg items-end">
                <div className="grid grid-cols-2 md:grid-cols-2 gap-4" >
                    <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Recolector</label>
                        <select className={inputClass} name="idRecolector" 
                        disabled = { formData.tipoPlan === 'Entrega' ? true : false}
                        value= {formData.idRecolector} 
                        onChange={handleChange}>
                          <option value=""></option>
                          {recolectoresData?.map((item, index) => (
                            <option  key={item._id} value={item._id}>{item.nombreRecolector}</option>
                          ))}  
                          </select> 
                    </div>
                    <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Drop Off</label>
                        <select className={inputClass} name="idDropoff" 
                        disabled = { formData.tipoPlan==='Entrega' ? false : true}
                        value= {formData.idDropoff} 
                        onChange={handleChange}>
                          <option value=""></option>
                          {puntosData?.map((item, index) => (
                            <option  key={item._id} value={item._id}>{item.nombrePunto}</option>
                          ))}  
                          </select> 
                    </div> 
                </div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-lg items-end">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4" >
                    <div className="col-span-4">
                      <div className="flex flex-col">
                          <label className="text-xs font-semibold mb-1">Observación</label>
                          <input
                              className={inputClass}
                              type="text"
                              placeholder=""
                              name="descripcion"
                              value= {formData.descripcion}
                              onChange={handleChange}
                            />
                      </div>  
                    </div> 
                    <div className="flex flex-col">
                        <label className="text-xs font-semibold mb-1">Estado</label>
                        <select className={inputClass} name="estado" value= {formData.estado} required onChange={handleChange}>   
                        <option value="Activo">Activo</option>
                        <option value="Bloqueado">Bloqueado</option>  
                        <option value="Eliminado">Eliminado</option>      
                        </select>
                    </div>  
                </div>

                <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
                  <div className="flex flex-col mt-4">
                    <ButtonToolBar buttons={buttonsTool} onButtonClick={handleButtonToolBarClick} />
                  </div>
                </div>

              </div>   
              <Toaster  position="top-right"  toastOptions={{  style: {  zIndex: 9999,  },  }} />         
              <FooterPages />  
          </div>

        </div>
      </div>
    </form>
  );
};

export default NuevaRegistro;